import React from 'react'
import {findDOMNode} from 'react-dom'

import Popover from "../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../gd-components/gd-popover/popover-position"
import {BUS_MODAL_SHOW} from "../../../app/ui/modal/modal-app"

type State = {
    showPopover     : boolean
    tourPanelShown  : boolean
}

type Props = {
    message                : string
}

export default class StartPopover extends React.Component<Props, State> {

    public parentEl         : any

    constructor(props: Props) {
        super(props)

        this.state = {
            showPopover     : true,
            tourPanelShown  : false,
        }
    }

    componentDidMount() {
        this.parentEl = findDOMNode(this)?.parentNode

        gd.bus.subscribe(BUS_MODAL_SHOW, this, this.updateVisibility)
        gd.bus.subscribe('gd-modal:hide', this, this.updateVisibility)
        gd.bus.subscribe('layout-new-toggle', this, this.updateVisibility)
        gd.bus.subscribe('layout-item-view-toggle', this, this.updateVisibility)
        gd.bus.subscribe("tour-panel:show", this, this.onTourPanelShow)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    updateVisibility = () => {
        const show = !gd.modal.isOpen && !gd.fullModalApp && !gd.itemView.isOpen && !gd.layout.new.isOpen;
        this.setState({
            showPopover: show
        })
    }

    onTourPanelShow = (value: boolean) => {
        this.setState({
            tourPanelShown: value
        })
    }

    render() {
        if (!this.state.showPopover || this.state.tourPanelShown) {
            return null
        }

        const hint = this.props.message.includes('\\n') ?
            this.props.message.split('\\n').map((text:any,key:any)=><p key={key}>{text}</p>) :
            this.props.message

        return (
            <Popover
                popoverClass    = "ui5-start-popover"
                className       = "no-bg min-w-250"
                position        = {PopoverPosition.bottomLeft()}
                enableArrows    = {false}
            >
                <div className="start-hint">
                    <div className="arrow ui5-ico-13 i5-long-arrow-up"/>
                    <div className="ui5-txt-not-important-tiny m-l-25 m-t-4">
                        {hint}
                    </div>
                </div>
            </Popover>
        )
    }
}
